import Dialog from "componentsv2/modal/Dialog";

/**
 *
 * @param {object} props - component props
 * @param {object} props.layout - object for render record
 * @param {object} props.onClose - object record to show
 * @param {boolean} props.open - true or false
 * @return {Component} - Modal Form for show form record
 */
function ModalAction({ layout, open, onClose, Component, size, reload, args }) {
  // if (!layout) return null;

  async function handleAction(btn) {
    console.log("Handle action....", btn);
    btn.method();
    handleClose();
  }

  async function handleClose(mustReload) {
    if (mustReload?.value && typeof reload === "function") {
      console.log(
        "Is necessary reload form or only parent???",
        mustReload.value,
      );
      reload();
    }

    await onClose(mustReload?.value);
    // if (reloadId) {
    //   reloadId.value++;
    // }
  }

  function getButtons() {
    const buttons = layout.buttons?.map((btn) => ({
      name: btn.name,
      label: btn.label,
      // onClick: btnField.method,
      onClick: handleAction,
      color: btn.color,
    }));
    console.log("Buttons", layout.buttons);
    return buttons;
  }

  console.log("Actionrender ? ", open);
  // const actionButtons = ;/
  return (
    <Dialog
      id="modal-form"
      size={size || "w-2/3 max-h-[90vh] 2xl:w-3/4"}
      openModal={open}
      handleClose={handleClose}
      buttons={getButtons()}
      title={layout.model}
      fixedHeight={true}
    >
      <Component
        // parentStoreId={parentStoreId}
        // parentRec={record}
        // signalReset={signalReset.value}
        layout={layout}
        onClose={onClose}
        model={layout.model}
        args={args}
        reload={reload}
      />
    </Dialog>
  );
}

export default ModalAction;
